/**
 * Subtle “why” line for security / architectural rationale from idwiz AI.
 */
export default function ArchitectsNote({ text, securityRecommendation = false }) {
  if (!text || !String(text).trim()) return null;

  return (
    <div
      className={`mt-2 rounded-lg border px-2.5 py-2 ${
        securityRecommendation
          ? "border-amber-500/15 bg-amber-500/[0.04]"
          : "border-white/[0.06] bg-white/[0.02]"
      }`}
    >
      <p className="text-[9px] font-semibold uppercase tracking-[0.12em] text-slate-500">idwiz AI note</p>
      <p
        className={`mt-1 text-[11px] leading-relaxed ${
          securityRecommendation ? "text-amber-100/85" : "text-slate-400"
        }`}
      >
        {text}
      </p>
    </div>
  );
}
